export class Status {
  authLoading: boolean = false;
  authErrorMsg: string = '';
}
